import { render, staticRenderFns } from "./MovingWords.vue?vue&type=template&id=05a94144&"
import script from "./MovingWords.vue?vue&type=script&lang=js&"
export * from "./MovingWords.vue?vue&type=script&lang=js&"
import style0 from "./MovingWords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports